var _a;
import React from "react";
import App from "./App";
import "./i18n";
import i18n from "./i18n";
import { Provider } from "react-redux";
import { I18nextProvider } from "react-i18next";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { store } from "@application/store";
import AppThemeProvider from "./ui/theme";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
const container = (_a = document.getElementById("root")) !== null && _a !== void 0 ? _a : document.createElement("root");
const root = createRoot(container);
root.render(React.createElement(React.StrictMode, null,
    React.createElement(I18nextProvider, { i18n: i18n },
        React.createElement(Provider, { store: store },
            React.createElement(BrowserRouter, null,
                React.createElement(LocalizationProvider, { dateAdapter: AdapterDayjs },
                    React.createElement(AppThemeProvider, null,
                        React.createElement(App, null))))))));
